import api from '../api';
import icons from '../../../../shared/utils/files/antIcons';
import getMess from '../translations';
import { ItemTypes } from '../../constants/constants';
import { siteUrls } from '../../../../shared/constants/siteUrls';

const label = 'createServiceRequest';

const handler = (apiOptions, actions) => {
  const { getSelectedResources, controlConfiguration } = actions;

  const selectedResource = getSelectedResources()[0];

  const fileId = selectedResource.id;

  const noteId = window?.ncFileManager?.noteId;
  const insuredId = window?.ncFileManager?.insuredId;

  const url = siteUrls.getServiceRequestCreateUrl(controlConfiguration.isMomentumEnabled, noteId, insuredId, fileId, true);

  window.open(url, '_blank', 'noopener');
};

export default (apiOptions, actions) => {
  const localeLabel = getMess(apiOptions.locale, label);
  const { getSelectedResources } = actions;

  return {
    id: label,
    icon: { icon: icons.star },
    label: localeLabel,
    resources: getSelectedResources(),
    shouldBeAvailable: () => {
      const selectedResources = getSelectedResources();
      return (
        selectedResources.length === 1 && selectedResources.every((resource) => resource.capabilities.canEdit && resource.type === ItemTypes.File)
      );
    },
    availableInContexts: ['row', 'toolbar'],
    handler: () => handler(apiOptions, actions),
  };
};
